import { apiClient } from "../../api/httpClient";
import { requestLawFirmFuzzyMatch } from "../../features/bonds/shared/utils/lawFirmFuzzyMatch";

export function formatLocationForCache(location) {
  return {
    value: location.law_firm_location_id ?? location.location_id,
    label: [location.name, location.city, location.state].filter(Boolean).join(" - "),
    name: location.name,
    address: location.address || "",
    city: location.city,
    state: location.state,
    zip_code: location.zip_code,
  };
}

export async function checkFuzzyLawFirmMatch(newLawFirm) {
  return requestLawFirmFuzzyMatch(apiClient, newLawFirm.name);
}

export async function createLawFirmWithLocation(newLawFirm) {
  const formData = new FormData();
  formData.append("name", newLawFirm.name);
  formData.append("website", newLawFirm.website || "");
  formData.append("accounting_contact_name", "");
  formData.append("accounting_contact_email", "");
  formData.append("accounting_contact_phone", "");
  formData.append("is_new", true);
  formData.append("is_active", true);
  formData.append("created_by_guest", true);

  const lawFirmResponse = await apiClient(
    "/create-a-lawfirm",
    "POST",
    formData,
    {},
    { "content-type": "multipart/form-data" }
  );

  const locationResponse = await apiClient("/lawfirm-location/", "POST", [
    {
      lawfirm_id: lawFirmResponse.lawfirm_id,
      name: "Main Location",
      address: newLawFirm.address,
      zip_code: newLawFirm.zip,
      city: newLawFirm.city,
      county: "",
      state: newLawFirm.state,
      phone: newLawFirm.phone,
      is_active: true,
    },
  ]);

  return { lawFirmResponse, locationResponse };
}

export function applyCreatedLawFirmToState({
  newLawFirm,
  lawFirmResponse,
  locationResponse,
  setAllLawFirms,
  setLawFirmLocationsByFirmId,
  setLawFirmData,
  setLawFirmLocations,
  setSelectedLawFirmLocation,
  setLawFirmSearch,
  setErrors,
}) {
  const firmId = lawFirmResponse.lawfirm_id;
  const newFirm = { label: newLawFirm.name, value: firmId };
  const loc = formatLocationForCache(locationResponse[0] || {});

  setAllLawFirms((prev) => [newFirm, ...prev.filter((f) => f.value !== firmId)]);
  setLawFirmLocationsByFirmId((prev) => ({
    ...prev,
    [firmId]: [loc],
  }));
  setLawFirmData({ lawFirm: firmId, lawFirmLocation: loc.value });
  setLawFirmLocations([loc]);
  setSelectedLawFirmLocation(loc);
  setLawFirmSearch("");
  setErrors((prev) => ({ ...prev, lawFirm: undefined }));
}

export function applyExistingLawFirmToState({
  fuzzyMatchResult,
  setAllLawFirms,
  setLawFirmData,
  setLawFirmSearch,
  setErrors,
}) {
  const existingFirm = { label: fuzzyMatchResult.name, value: fuzzyMatchResult.id };
  setAllLawFirms((prev) => {
    const has = prev.some((f) => f.value === fuzzyMatchResult.id);
    return has ? prev : [existingFirm, ...prev];
  });
  setLawFirmData((prev) => ({ ...prev, lawFirm: fuzzyMatchResult.id, lawFirmLocation: "" }));
  setLawFirmSearch("");
  setErrors((prev) => ({ ...prev, lawFirm: undefined }));
}
